import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { isExists } from 'src/shared/journal/utils';

@Component({
  selector: 'app-table-cell-enum-renderer',
  templateUrl: './table-cell-enum-renderer.component.html',
  styleUrls: ['./table-cell-enum-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellEnumRendererComponent implements ICellRendererAngularComp {
  value = '';
  enumCode = null;
  constructor(private cdr: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.applyParams(params);
    this.cdr.markForCheck();
    return false;
  }

  agInit(params: ICellRendererParams<any, any>): void {
    this.applyParams(params);
  }

  private applyParams(params: ICellRendererParams) {
    const value = params.value;
    this.enumCode = params.colDef?.cellRendererParams.enumCode;
    if (isExists(value)) {
      this.value = value.toString();
    }
  }
}
